import React, { forwardRef } from 'react';
import { styled } from '../../utils';
import { Stack } from '../Stack';
import { Typography } from '../Typography';
import { PopoverBase, PopoverBaseProps } from './PopoverBase';

export interface PopoverProps extends PopoverBaseProps {
  /**
   * An optional title for the popover.
   */
  title?: string;
}

/**
 * This component is meant to fulfill the Spotlight design for a Popover.
 * Use PopoverBase if you need a lower-level component.
 */
export const Popover = forwardRef<HTMLDivElement, PopoverProps>(function Popover(
  { placement = 'bottom-start', title, Content, onClose, children, ...props },
  ref
) {
  return (
    <PopoverBase
      {...props}
      ref={ref}
      placement={placement}
      onClose={onClose}
      Content={({ closePopover }) => (
        <PopoverContentRoot spacing={1}>
          {title && <Typography variant="h3">{title}</Typography>}
          {typeof Content === 'function' ? Content({ closePopover }) : Content}
        </PopoverContentRoot>
      )}
    >
      {children}
    </PopoverBase>
  );
});

export const POPOVER_ROOT_PADDING = 2;

const PopoverContentRoot = styled(Stack)(({ theme }) => {
  return {
    padding: theme.spacing(POPOVER_ROOT_PADDING),
  };
});
